import { useEventListener } from '@vueuse/core';
import { getTrans } from '@/js/helpers/getTrans';

const handleButtonClick = (button: HTMLDivElement, textBlock: HTMLElement, description: HTMLDivElement) => {
    const isExpanded = textBlock.classList.contains('expanded');

    if (isExpanded) {
        button.textContent = getTrans('about-us.readMore', 'Read more');
        description.style.display = '-webkit-box';
        textBlock.classList.remove('expanded');
    } else {
        button.textContent = getTrans('cryptocurrencies.readLess', 'Read less');
        description.style.display = 'block';
        textBlock.classList.add('expanded');
    }
};

const addEvents = () => {
    const buttons = document.querySelectorAll<HTMLDivElement>('.read-more-button');

    buttons.forEach((button) => {
        const textBlock = button.parentElement?.parentElement;

        if (!textBlock) {
            return;
        }

        const description: HTMLDivElement = textBlock.querySelector('.author-description') || textBlock.querySelector('.expert-description');

        if (!description) {
            return;
        }

        if (description.scrollHeight > description.clientHeight) {
            useEventListener(button, 'click', () => handleButtonClick(button, textBlock, description));
        } else {
            button.style.display = 'none';
        }
    });
};

useEventListener(document, 'DOMContentLoaded', addEvents);
